import fetchWithAuthorization from './fetch-with-authorization'
import { END_POINTS } from './end-points'
import { buildSearchParams } from './build-search-params'
import { DEFAULT_PER_PAGE } from '@/data/constants'

export const fetchRewardsRules = async (
  page = 1,
  perPage = DEFAULT_PER_PAGE,
  sortBy = 'startDate',
  fields = null,
  searchValue = null,
  orderBy = null
) => {
  const searchParams = buildSearchParams({
    page,
    perPage,
    sortBy,
    orderBy,
    searchValue,
    fields,
  })

  const path = `/api/reward-rule?${searchParams.toString()}`

  const response = await fetchWithAuthorization({
    path,
  })
  return { data: response.data, meta: response.meta }
}

export const createRewardsRule = async ruleData => {
  const response = await fetchWithAuthorization({
    path: END_POINTS.REWARDS_RULE.CREATE_RULE,
    method: 'POST',
    body: JSON.stringify(ruleData),
  })
  return response
}
